import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';

/**
 * Default exclusion rules for AWEntitlements AGraph/Cloud APIs that reject unknown query params
 */
const AW_PORTFOLIOS_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: ['models/v1/models', 'portfolios/v1/aggregates', 'portfolios/v1/accounts'],
    excludedParams: ['configurationDirectory', 'pkg'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWEntitlements endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_PORTFOLIOS_PARAM_EXCLUSION_RULES);
}
